import React, { useState, useEffect } from 'react';
import { pdf } from '@react-pdf/renderer';
import MyDocument from './TranscriptMyDocument';
import { Container,Spinner } from 'react-bootstrap';
import {Download, Eye } from 'react-bootstrap-icons';
import axios from 'axios';
import { useAppContext } from "../../contexts/AppContext";
import Select from "react-select";
import {
  
  queryGroups,
  
  getAllGroupMembers,
} from "../../services/poweruserServices";

const TranscriptPDFButton = () => {
 const [selectBoxValuesGroup, setSelectBoxValuesGroup] = useState();
 const [defaultListGroupOptions, setDefaultListGroupOptions] = useState([]);
const [groupUsers, setGroupUsers] = useState([]);
const [isListBoxLoading, setIsListBoxLoading] = useState(false);
const [defaultListOptions, setDefaultListOptions] = useState([]);
const [selectBoxValuesUser, setSelectBoxValuesUser] = useState(null);
const [data, setData] = useState([]);
const [changesUserName, setChangesUserName] = useState("");
const [transcriptData, setTranscriptData] = useState([]);
const { currentUser } = useAppContext();
const [loading, setLoading] = useState(true);
const [apiFetch, setApiFetch] = useState(false);
const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
      (async () => {
        
  
          if(currentUser.isPowerUser)
          {
          
               setLoading(false);
               defaultListGroupOptions.length <= 0 && getPowerUserGroups();
               setIsDisabled(true);

          }
          else{
            setChangesUserName(currentUser.username);
          //  await getUserCourses();
          await fetchTranscript(currentUser.username);
           setIsDisabled(false);

          }
      
      })();
    }, [])
  
    
      const getPowerUserGroups = async () => {
        setIsListBoxLoading(true);
        let userGroups = await queryGroups(currentUser.user_id);
    
        var result = userGroups.map((item) => {
          return { value: item.id, label: item.name, type: "group" };
        });
    
        setDefaultListGroupOptions(result);
        setIsListBoxLoading(false);
    
         if (result.length > 0) {
        const firstGroup = result[0];
        setSelectBoxValuesGroup(firstGroup); 
        await handleSelectChangeGroup(firstGroup); 
      }
    
        return result;
      };
       const filterOptions = (candidate, input) => {
  const search = input.toLowerCase();

  return (
    candidate.data.label.toLowerCase().includes(search) ||
    candidate.data.email.toLowerCase().includes(search) ||
    candidate.data.value.toString().toLowerCase().includes(search) ||
    candidate.data.firstname.toLowerCase().includes(search) ||
      candidate.data.lastname.toLowerCase().includes(search) ||

      (candidate.data.firstname + ' ' + candidate.data.lastname)
          .toLowerCase()
          .includes(search)
  );
};
   const handleSelectChangeGroup = async (selectedOptions) => {
       setIsDisabled(true);
       setApiFetch(false);
      setIsListBoxLoading(true);
      setSelectBoxValuesGroup(selectedOptions);
      //  console.log(selectedOptions);
      // let userGroups = await queryGroups(currentUser.user_id);
      let groupId = selectedOptions.value.toString();
      let groupUsers = await getAllGroupMembers(groupId);
  
      let listGroupUsers = groupUsers.map((item) => {
        return {
          value: item.id,
          label: item.username + " ( " + item.firstname + " " + item.lastname + " )",
          type: "user",
          email: item.email,
          firstname:item.firstname,
          lastname:item.lastname,
          username:item.username,
        };
      });
       setGroupUsers(listGroupUsers);
      setDefaultListOptions(listGroupUsers);
      setIsListBoxLoading(false);
      
          setSelectBoxValuesUser([]);
      return listGroupUsers;
    }
   const handleSelectChangeUser = async (selectedOptions) => {
   setIsDisabled(false);
  setLoading(true);

    setSelectBoxValuesUser(selectedOptions);
     let userId = selectedOptions.value.toString();
     
     const filteredUsers = defaultListOptions.filter(user =>
  user.value.toString()=== userId);

   setChangesUserName(filteredUsers[0].username);
  await fetchTranscript(filteredUsers[0].username);
  
   }
   const fetchTranscript = async (userName) => {
    //userName="500440489257";
  //const endPoint = `https://h62vn3twk3.execute-api.us-west-2.amazonaws.com/prod/SF_Inbound/learner/${userName}/transcript`;
       setApiFetch(false);
  try {
     const response = await axios.post(
         `${process.env.REACT_APP_API_DOMAIN}/course/transcript${window.location.search}`,
            {
                UserName: userName
              }
          );

   // console.log('Transcript data:', response);
    setTranscriptData( response.data);
    setLoading(false);
    return response.data;
  } catch (error) {
     setIsDisabled(true);
    setApiFetch(true);
    setLoading(false);
     setTranscriptData([]);
    console.error('Error fetching transcript:', error);
    throw error;
  }
};

  const handleOpenPDF = async (userNames) => {
    try {
     // const response = await axios.get('/api/transcript'); // Replace with your actual API
     setLoading(true);
      setData(transcriptData);
     // console.log(transcriptData);
      var userName1="";
      var firstName1="";
      var lastName1="";
      if(currentUser.isPowerUser)
      {
       
        const filteredUsers = defaultListOptions.filter(user =>
        user.username.toLowerCase() === userNames.toLowerCase());

         userName1=userNames;
         firstName1=filteredUsers[0].firstname;
          lastName1=filteredUsers[0].lastname;
      }
      else
      {
        userName1=currentUser.username;
         firstName1=currentUser.first_name;
          lastName1=currentUser.last_name;
      }
      // userName1="100091589807";
      // firstName1="YAKOV";
      // lastName1="YEZHEVSKY";
     var dob= transcriptData.length > 0 ? transcriptData[0].dob : "-";
     userName1=transcriptData.length > 0 ? transcriptData[0].personid : userName1;
     firstName1=transcriptData.length > 0 ? transcriptData[0].firstname : firstName1;
     lastName1=transcriptData.length > 0 ? transcriptData[0].lastname : lastName1;
      const blob = await pdf(<MyDocument data={transcriptData} firstName={firstName1} lastName={lastName1} userName={userName1} dob={dob}/>).toBlob();
      const url = URL.createObjectURL(blob);
      setLoading(false);
      window.open(url, '_blank');
//    const link = document.createElement('a'); 
// link.href = url;
// link.download = "Transcript_Akhilesh.pdf"; 
// document.body.appendChild(link); 
// link.click(); 
// document.body.removeChild(link); 

    } catch (error) {
      setLoading(false);
      console.error('Failed to fetch transcript data', error);
    }
  };
 const DownLoadPDF = async (userNames) => {
    try {
     // const response = await axios.get('/api/transcript'); // Replace with your actual API
     setLoading(true);
      setData(transcriptData);
   
      var userName1="";
      var firstName1="";
      var lastName1="";
      if(currentUser.isPowerUser)
      {
       
        const filteredUsers = defaultListOptions.filter(user =>
        user.username.toLowerCase() === userNames.toLowerCase());

         userName1=userNames;
         firstName1=filteredUsers[0].firstname;
          lastName1=filteredUsers[0].lastname;
      }
      else
      {
        userName1=currentUser.username;
         firstName1=currentUser.first_name;
          lastName1=currentUser.last_name;
      }
    userName1=transcriptData.length > 0 ? transcriptData[0].personid : userName1;
     firstName1=transcriptData.length > 0 ? transcriptData[0].firstname :firstName1;
     lastName1=transcriptData.length > 0 ? transcriptData[0].lastname : lastName1;
     var dob= transcriptData.length > 0 ? transcriptData[0].dob : "-";
      const blob = await pdf(<MyDocument data={transcriptData} firstName={firstName1} lastName={lastName1} userName={userName1} dob={dob}/>).toBlob();
      const url = URL.createObjectURL(blob);
      
     // window.open(url, '_blank');
   const link = document.createElement('a'); 
link.href = url;
link.download = firstName1+" "+lastName1+"_"+userName1+".pdf"; 
document.body.appendChild(link); 
link.click(); 
setLoading(false);
document.body.removeChild(link); 

    } catch (error) {
      console.error('Failed to fetch transcript data', error);
    }
  };
  return (
    <div className="container-card">
      <div className="container-header">
        <div>
          <div className="container-heading mt-1">Transcript</div>
          <div style={{ color: "#441968", font: "14px" }}>
            View or print your official transcript using the buttons below.
           
  <ul style={{ paddingLeft: "20px", margin: 0 }}>
    <li>Online course completions display within 1 business day.</li>
    <li>In-person and webinar courses display within 1 - 2 business days.</li>
  </ul>

          </div>
        </div>
      </div>
      <div className="container-card-body">
    <Container className="position-relative pt-5 " style={{ height: '250px' }}>
        {loading && <div className='position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-transparent z-100'><Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner></div>}
      {currentUser.isPowerUser && <><div className="d-flex justify-content-center align-items-center " style={{ width: '100%'}}>
 <div style={{ width: '200px' }}>
                 Select Group{" "} 
                <Select
                  
                  options={defaultListGroupOptions}
                  onChange={handleSelectChangeGroup}
                  isLoading={isListBoxLoading}
                  
                  value={selectBoxValuesGroup} 
                />
                
              </div>&nbsp;&nbsp;
               <div style={{ width: '300px' }}>
                  Select Username / Person ID{" "}
                <Select
                
                  options={defaultListOptions}
                    filterOption={filterOptions}
                  onChange={handleSelectChangeUser}
                  isLoading={isListBoxLoading}
                  value={selectBoxValuesUser}
                />
              
              </div>
       
        
      </div><div  className="d-flex justify-content-center  align-items-center pt-1" style={{ fontSize:'12px'}}><div style={{ width: '200px' }}></div>&nbsp;&nbsp;<div style={{ width: '300px' }}>Start typing the caregiver's name or BG Person to search</div></div></>}
      <div className="d-flex justify-content-center  align-items-center pt-3" style={{ width: '100%' }}>
      <div className={`btn primary ${isDisabled ? 'disabled' : ''}`}
 onClick={()=>handleOpenPDF(changesUserName)}>
        <Eye size={20} color="white" /> &nbsp; View Transcript
      </div>&nbsp;&nbsp;&nbsp;
       <div className={`btn primary ${isDisabled ? 'disabled' : ''}`}
 onClick={()=>DownLoadPDF(changesUserName)}>
         <Download size={20} color="white" /> &nbsp;  Download Transcript 
      </div>
          </div>
          {apiFetch && <div className="d-flex justify-content-center  align-items-center pt-2" style={{ width: '100%', color: 'red' }}>
              There was an error while generating transcript data. Please contact MRC@myseiubenefits.org
          </div>}
    </Container>
    </div>
    </div>
  );
};
 

export default TranscriptPDFButton;
